import { JobType } from "../enums/JobType";
import { LocationType } from "../enums/LocationType";
import { SeniorityLevel } from "../enums/SeniorityLevel";
import { VacancyStatus } from "../enums/VacancyStatus";
import { InterviewStatus } from "../enums/InterviewStatus";
import { Department } from "../enums/Department";

export const getJobTypeLabel = (value: JobType): string => {
  switch (value) {
    case JobType.Permanent:
      return "Permanent";
    case JobType.PartTime:
      return "Part Time";
    case JobType.Temporary:
      return "Temporary";
    case JobType.Contract:
      return "Contract";
    case JobType.Internship:
      return "Internship";
    case JobType.Volunteer:
      return "Volunteer";
    default:
      return "";
  }
};

export const getLocationTypeLabel = (value: LocationType): string => {
  switch (value) {
    case LocationType.Remote:
      return "Remote";
    case LocationType.OnSite:
      return "On-Site";
    case LocationType.Hybrid:
      return "Hybrid";
    default:
      return "";
  }
};

export const getSeniorityLevelLabel = (value: SeniorityLevel): string => {
  switch (value) {
    case SeniorityLevel.Junior:
      return "Junior";
    case SeniorityLevel.Mid:
      return "Mid";
    case SeniorityLevel.Senior:
      return "Senior";
    case SeniorityLevel.Lead:
      return "Lead";
    case SeniorityLevel.Principal:
      return "Principal";
    default:
      return "";
  }
};

export const getVacancyStatusLabel = (value: VacancyStatus): string => {
  switch (value) {
    case VacancyStatus.Active:
      return "Active";
    case VacancyStatus.Closed:
      return "Closed";
    case VacancyStatus.Expired:
      return "Expired";
    default:
      return "";
  }
};

export const getInterviewStatusLabel = (value: string): string => {
  switch (value) {
    case InterviewStatus.Scheduled:
      return "Scheduled";
    case InterviewStatus.InProgress:
      return "In Progress";
    case InterviewStatus.Completed:
      return "Completed";
    case InterviewStatus.Failed:
      return "Failed";
    case InterviewStatus.AwaitingSelection:
      return "Awaiting for candidate to select the time";

    default:
      return value;
  }
};

export const getDepartmentLabel = (value: Department): string => {
  switch (value) {
    case Department.Accounting:
      return "Accounting";
    case Department.Admin:
      return "Admin";
    case Department.Advertising:
      return "Advertising";
    case Department.Defence:
      return "Defence";
    case Department.Agriculture:
      return "Agriculture";
    case Department.Aviation:
      return "Aviation";
    case Department.Entertainment:
      return "Entertainment";
    case Department.Banking:
      return "Banking";
    case Department.Construction:
      return "Construction";
    case Department.BusinessManagement:
      return "Business Management";
    case Department.CallCentre:
      return "Call Centre";
    case Department.Petrochemical:
      return "Petrochemical";
    case Department.SocialServices:
      return "Social Services";
    case Department.DesignServices:
      return "Design Services";
    case Department.Warehousing:
      return "Warehousing";
    case Department.Education:
      return "Education";
    case Department.Engineering:
      return "Engineering";
    case Department.FMCG:
      return "FMCG";
    case Department.GovernmentAndParastatals:
      return "Government And Parastatals";
    case Department.Sports:
      return "Sports";
    case Department.Hospitality:
      return "Hospitality";
    case Department.HumanResources:
      return "Human Resources";
    case Department.IT:
      return "IT";
    case Department.Insurance:
      return "Insurance";
    case Department.Investment:
      return "Investment";
    case Department.Legal:
      return "Legal";
    case Department.Logistics:
      return "Logistics";
    case Department.Manufacturing:
      return "Manufacturing";
    case Department.Marketing:
      return "Marketing";
    case Department.Medical:
      return "Medical";
    case Department.Mining:
      return "Mining";
    case Department.General:
      return "General";
    case Department.Media:
      return "Media";
    case Department.RealEstate:
      return "Real Estate";
    case Department.Retail:
      return "Retail";
    case Department.Security:
      return "Security";
    case Department.Sales:
      return "Sales";
    case Department.Technology:
      return "Technology";
    case Department.Telecommunications:
      return "Telecommunications";
    case Department.Clothing:
      return "Clothing";
    case Department.TradesAndServices:
      return "Trades And Services";
    case Department.TravelAndTourism:
      return "Travel And Tourism";
    case Department.Finance:
      return "Finance";
    case Department.Automotive:
      return "Automotive";
    case Department.Academic:
      return "Academic";
    case Department.Chemical:
      return "Chemical";
    case Department.Fashion:
      return "Fashion";
    case Department.ImportAndExport:
      return "Import And Export";
    case Department.HealthFitnessAndBeauty:
      return "Health Fitness And Beauty";
    case Department.Management:
      return "Management";
    case Department.Consulting:
      return "Consulting";
    case Department.Motoring:
      return "Motoring";
    case Department.NGOAndNonProfit:
      return "NGO And Non Profit";
    case Department.PRAndCommunication:
      return "PR And Communication";
    case Department.Procurement:
      return "Procurement";
    case Department.Property:
      return "Property";
    case Department.Purchasing:
      return "Purchasing";
    case Department.Research:
      return "Research";
    case Department.Stockbroking:
      return "Stockbroking";
    default:
      return "";
  }
};
